import { refusalWords } from "@/services/api-client";
import { Button } from "@/components/ui/button";

/**
 * A gate the server could not answer for. Told apart from a closed gate: the
 * attorney has nothing to settle, only a request to send again.
 */
export function Unanswered({
  what,
  error,
  onRetry,
}: {
  /** What could not be checked, as the sentence's subject. */
  what: string;
  error: unknown;
  onRetry: () => void;
}) {
  const words = refusalWords(error);
  return (
    <p
      role="alert"
      className="mt-2 flex flex-wrap items-center gap-2 text-[11.5px] text-destructive"
    >
      <span>
        {what} could not be checked.
        {words === null ? "" : ` ${words}`}
      </span>
      <Button variant="secondary" size="dense" type="button" onClick={onRetry}>
        Try again
      </Button>
    </p>
  );
}
